<template>
  <div>
    <v-toolbar card color="white">
      <v-toolbar-title>Báo cáo tăng ca</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn round outline color="success" dark v-show="checkPermission()" :loading="isExporting" @click="exportToGoogleSheet()">Ghi ra Google Sheet <v-icon>assignment</v-icon></v-btn>
      <v-toolbar-items>
        <v-combobox 
          solo 
          class="toolbar-item" 
          v-model="selectedGroup" 
          item-text="Name" 
          item-value="Id" 
          :items="group" 
          label="Group" 
          @change="handleChangeGroup">
        </v-combobox>
        <v-menu
          v-model="menuFromDate"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="fromDate"
              prepend-inner-icon="event"
              readonly
              v-on="on"
              solo
              class="date-box"
            ></v-text-field>
          </template>
          <v-date-picker v-model="fromDate" @input="menuFromDate = false"></v-date-picker>
        </v-menu>
        <v-menu
          v-model="menuToDate"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="toDate"
              prepend-inner-icon="event"
              readonly
              v-on="on"
              solo
              class="date-box"
            ></v-text-field>
          </template>
          <v-date-picker v-model="toDate" @input="menuToDate = false"></v-date-picker>
        </v-menu>
      </v-toolbar-items>
      <v-btn class="mx-0" color="primary" @click="fetchData" :disabled="disabledDownload">Download</v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
      item-key="id"
      :headers="table.headers"
      :items="dataFilter"
      :rows-per-page-items="[10,20,50,100]"
      :loading="isLoading"
      class="table-ot"
      ref="tableOT"
      @update:pagination="updatePagination"
    >
      <template slot="items" slot-scope="props">
        <tr class="table-row">
          <td>{{ props.item.Date }}</td>
          <td style="width: 150px">{{ props.item.Name }}</td>
          <td>{{ props.item.InstallationTrackerQty }}</td>
          <td>{{ props.item.InstallationCameraQty }}</td>
          <td>{{ props.item.InstallationSensorQty }}</td>
          <td>{{ props.item.InstallationTaxiQty }}</td>
          <td>{{ props.item.RepairTrackerQty }}</td>
          <td>{{ props.item.RepairCameraQty }}</td>
          <td>{{ props.item.RepairSensorQty }}</td>
          <td>{{ props.item.RepairTaxiQty }}</td>
          <td>{{ props.item.InstallationSummary }}</td>
          <td>{{ props.item.RepairSummary }}</td>
          <td>{{ props.item.OT }}</td>
          <td>{{ props.item.Distance }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import validate from '@/utils/validate';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { formatGMTToLocalTime, convertDateTimeToSecond2010, convertSecond2010ToDateTime, getBeginOfDayAsSecond, getEndOfDayAsSecond } from '@/utils/datetime';
import moment from 'moment';
import * as MapUtil from '@/utils/maputil';

export default {
  components: {
  },
  data () {
    return {
      table: {
        headers: [
          {
            text: 'Ngày',
            value: 'Date'
          },
          {
            text: 'Nhân viên',
            value: 'Name'
          },
          {
            text: 'Tracker (LĐ)',
            value: 'InstallationTrackerQty'
          },
          {
            text: 'Camera (LĐ)',
            value: 'InstallationCameraQty'
          },
          {
            text: 'Sensor (LĐ)',
            value: 'InstallationSensorQty'
          },
          {
            text: 'Taxi (LĐ)',
            value: 'InstallationTaxiQty'
          },
          {
            text: 'Tracker (SC)',
            value: 'RepairTrackerQty'
          },
          {
            text: 'Camera (SC)',
            value: 'RepairCameraQty'
          },
          {
            text: 'Sensor (SC)',
            value: 'RepairSensorQty'
          },
          {
            text: 'Taxi (SC)',
            value: 'RepairTaxiQty'
          },
          {
            text: 'SLLĐ',
            value: 'InstallationSummary'
          },
          {
            text: 'SLSC',
            value: 'RepairSummary'
          },
          {
            text: 'Tăng ca (h)',
            value: 'OT'
          },
          {
            text: 'Km',
            value: 'Distance'
          }
        ]
      },
      datasource: [],
      fromDate: moment().format('YYYY-MM-DD'),
      menuFromDate: false,
      toDate: moment().format('YYYY-MM-DD'),
      menuToDate: false,
      isLoading: false,
      userCanExportToGoogleSheet: ['luantv@vietmap.vn', 'nhungtt@vietmap.vn'],
      isExporting: false,
      group: [],
      selectedGroup: null,
      disabledDownload: true,
      dataFilter: [] 
    };

  },
  computed: {
    ...mapGetters(['loggedUser'])
  },
  watch: {
    fromDate () {
      // this.fetchData();
    },
    toDate () {
      // this.fetchData();
    },
    // selectedGroup () {
    //   this.filterDataByGroup();
    // }
  },
  async created () {
    await this.getGroup();
    await this.fetchData();
  },

  mounted () {
    // this.$refs.tableOT
    // console.log('TCL: mounted -> this.$refs.tableO', this.$refs.tableOT);
  },

  methods: {
    ...mapActions(['GetSupporters', 'GetAllCases', 'VehicleDailyReport', 'WriteReportToGoogleSheet', 'GetAllTicket', 'GetAllTechnicalUser', 'GetUserGroup']),
    async fetchData () {
      this.disabledDownload = true;
      this.isLoading = true;
      let data = [];

      let from = moment(this.fromDate);
      let to = moment(this.toDate);

      let sups = await this.GetAllTechnicalUser();
      // console.log('TCL: fetchData -> sups', JSON.stringify(sups));
      let cases = await this.GetAllTicket();
      // console.log('🚀 ~ file: Detail.vue ~ line 212 ~ fetchData ~ cases', cases);

      let params = {
        Ids: sups.map(a => a.VehicleId),
        From: getBeginOfDayAsSecond(from),
        To: getEndOfDayAsSecond(to)
      };
      let dailyReport = await this.VehicleDailyReport(params).catch(_ => { return null });
      console.log('🚀 ~ file: Detail.vue ~ line 230 ~ fetchData ~ dailyReport', dailyReport);

      if (!dailyReport) {
        this.isLoading = false;
        return;
      }

      let casesFilterd = cases.filter(a => moment(a.Plan) >= moment(from).startOf('day') && moment(a.Plan) <= moment(to).endOf('day'));  
      console.log('🚀 ~ file: Detail.vue ~ line 221 ~ fetchData ~ casesFilterd', casesFilterd);
      sups.map(s => {
        // eslint-disable-next-line eqeqeq
        let reportBySup = dailyReport.filter(a => a.VehicleId == s.VehicleId);
        let casesBySup = casesFilterd.filter(a => (a.RepairPerson === s.Name) || ((a.RepairPerson !== s.Name) && a.RepairPersonList && a.RepairPersonList.includes(s.Username)));

        let sum = (prop, date) => {
          let arr = casesBySup.map(a => (convertSecond2010ToDateTime(date).date() === moment(a.Plan).add(7, 'hours').date() ? a[`${prop}`] : 0));
          let res = arr.reduce((acc, curr) => Number(acc) + Number(curr), 0);
          return res > 0 ? res : '';
        };

        let convertToLocalTime = time => {
          return moment(time).add(7, 'hours');
        };

        let minutesOfDay = m => {
          if (m instanceof String) { m = convertToLocalTime(m) }
          m = moment(m);
          return m.minutes() + m.hours() * 60;
        };
        
        let calcOT = (date) => {
          let arr = casesBySup.map(a => (convertSecond2010ToDateTime(date).date() === moment(a.Plan).add(7, 'hours').date() ? a : null));
          let ot = 0;
          let isAddComingHomeTime = false;
          let dayOfWeek = convertSecond2010ToDateTime(date).day();

          // eslint-disable-next-line complexity
          arr.map(a => {
            let beginWorkTime = moment(new Date(2010, 1, 1, 1, 30, 0)); // convertToLocalTime trước 8h30
            let endWorkTime = moment(new Date(2010, 1, 1, 10, 0, 0));// convertToLocalTime sau 17h

            if (a && a.Started && a.Finished) {
              if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Không phải CN, T7
                // check trước 8h30
                if (minutesOfDay(a.Started) <= minutesOfDay(beginWorkTime)) {
                  if (minutesOfDay(a.Finished) <= minutesOfDay(beginWorkTime)) {
                    let t = minutesOfDay(a.Finished) - minutesOfDay(a.Started);
                    ot += t / 60;
                  } else {
                    let t = minutesOfDay(beginWorkTime) - minutesOfDay(a.Started);
                    ot += t / 60;
                  }
                }
                // check sau 17h
                if (minutesOfDay(a.Started) >= minutesOfDay(endWorkTime) || minutesOfDay(a.Finished) >= minutesOfDay(endWorkTime)) {
                  if (minutesOfDay(a.Started) <= minutesOfDay(endWorkTime)) {
                    let t = minutesOfDay(a.Finished) - minutesOfDay(endWorkTime);
                    ot += t / 60;
                  } else {
                    let t = minutesOfDay(a.Finished) - minutesOfDay(a.Started);
                    ot += t / 60;

                  }
                }
                // cộng 30p sau khi kết thúc case cuối
                if (ot && !isAddComingHomeTime) {
                  ot += 0.5;
                  isAddComingHomeTime = true;
                }
              }
              else { // T7 CN

                if (dayOfWeek === 6) { // T7
                  endWorkTime = moment(new Date(2010, 1, 1, 5, 0, 0)); // convertToLocalTime sau 12h

                  // check trước 8h30
                  if (minutesOfDay(a.Started) <= minutesOfDay(beginWorkTime)) {
                    if (minutesOfDay(a.Finished) <= minutesOfDay(beginWorkTime)) {
                      let t = minutesOfDay(a.Finished) - minutesOfDay(a.Started);
                      ot += t / 60;
                    } else {
                      let t = minutesOfDay(beginWorkTime) - minutesOfDay(a.Started);
                      ot += t / 60;
                    }
                  }

                  // check sau 12h
                  if (minutesOfDay(a.Started) >= minutesOfDay(endWorkTime) || minutesOfDay(a.Finished) >= minutesOfDay(endWorkTime)) {
                    if (minutesOfDay(a.Started) <= minutesOfDay(endWorkTime)) {
                      let t = minutesOfDay(a.Finished) - minutesOfDay(endWorkTime);
                      ot += t / 60;
                    } else {
                      let t = minutesOfDay(a.Finished) - minutesOfDay(a.Started);
                      ot += t / 60;
                    }
                  }
                }

                if (dayOfWeek === 0) { // CN
                  // Thời gian làm việc của case
                  let t = minutesOfDay(a.Finished) - minutesOfDay(a.Started);
                  ot += t / 60;
                }

                // 30p chạy từ nhà ra điểm lắp đặt đầu tiên và 30p chạy từ điểm lắp đặt cuối cùng về nhà
                if (ot && !isAddComingHomeTime) {
                  ot += dayOfWeek === 6 ? 0.5 : 1; // T7 chỉ tính 30p chạy từ điểm lắp đặt cuối cùng về nhà
                  isAddComingHomeTime = true;
                }

              }
              // Thời gian chờ xe
              if (a.WaitingLocation && a.WaitingFrom) {
                let distance = 0;
                let latlng1 = a.WaitingLocation.split(',');
                let latlng2 = a.Location.split(',');

                try {
                  distance = MapUtil.calcDistance(
                    latlng1[0],
                    latlng1[1],
                    latlng2[0],
                    latlng2[1],
                    'K'
                  );
                  // eslint-disable-next-line max-depth
                  if (distance < 1) {
                    let t = minutesOfDay(a.Started) - minutesOfDay(a.WaitingFrom);
                    ot += t / 60;
                  }
                } catch (error) {
                  // console.log('TCL: calcOT -> error', error);
                }
              }
            }

            return 0;
          });
          return ot > 0 ? ot.toFixed(2) : '';
        };
        
        reportBySup.map(a => {
          if (a.FromTime) {
            let item = {
              Group: s.Group,
              Name: s.Name,
              Date: a.FromTime > 0 ? convertSecond2010ToDateTime(a.FromTime).format('YYYY-MM-DD') : '',
              Distance: a.GpsDistance > 0 ? (a.GpsDistance / 1000).toFixed(1) : '',
              InstallationTrackerQty: sum('InstallationTrackerQty', a.FromTime),
              InstallationCameraQty: sum('InstallationCameraQty', a.FromTime),
              InstallationSensorQty: sum('InstallationSensorQty', a.FromTime),
              InstallationTaxiQty: sum('InstallationTaxiQty', a.FromTime),
              InstallationSummary: 0,
              RepairTrackerQty: sum('RepairTrackerQty', a.FromTime),
              RepairCameraQty: sum('RepairCameraQty', a.FromTime),
              RepairSensorQty: sum('RepairSensorQty', a.FromTime),
              RepairTaxiQty: sum('RepairTaxiQty', a.FromTime),
              RepairSummary: 0,
              OT: calcOT(a.FromTime)
            };

            item.InstallationSummary = Number(item.InstallationTrackerQty) + Number(item.InstallationCameraQty) + Number(item.InstallationSensorQty) + Number(item.InstallationTaxiQty);
            item.RepairSummary = Number(item.RepairTrackerQty) + Number(item.RepairCameraQty) + Number(item.RepairSensorQty) + Number(item.RepairTaxiQty);

            item.InstallationSummary = item.InstallationSummary > 0 ? item.InstallationSummary : '';
            item.RepairSummary = item.RepairSummary > 0 ? item.RepairSummary : '';

            data.push(item);
          }
          return 0;
        });
        return 0;
      });
      this.datasource = data;
      this.filterDataByGroup();
      this.isLoading = false;
      this.disabledDownload = false;
    },
    checkPermission () {
      // return this.userCanExportToGoogleSheet.includes(this.loggedUser.Email) && this.datasource.length > 0;
    },
    async exportToGoogleSheet () {
      this.isExporting = true;
      let data = [];

      let sorted = this.datasource.sort((a, b) => {
        let timeA = moment(a.Date);
        let timeB = moment(b.Date);
        return timeA - timeB;
      });
      
      data = sorted.map(a => {
        let item = [];
        item.push(`${a.Date}`);
        item.push(`${a.Name}`);
        item.push(`${a.InstallationTrackerQty}`);
        item.push(`${a.InstallationCameraQty}`);
        item.push(`${a.InstallationSensorQty}`);
        item.push(`${a.InstallationTaxiQty}`);
        item.push(`${a.RepairTrackerQty}`);
        item.push(`${a.RepairCameraQty}`);
        item.push(`${a.RepairSensorQty}`);
        item.push(`${a.RepairTaxiQty}`);
        item.push(`${a.InstallationSummary}`);
        item.push(`${a.RepairSummary}`);
        item.push(`${a.OT}`);
        item.push(`${a.Distance}`);
        return item;
      });
      
      let res = await this.WriteReportToGoogleSheet({ Data: data });
      if (res) {
        window.getApp.showMessage('Ghi dữ liệu ra Google Sheet thành công');
      }
      this.isExporting = false;
    },

    filterDataByGroup () {
      if (this.selectedGroup.Id) this.dataFilter = this.datasource.filter(item => item.GroupId === this.selectedGroup.Id);
      else this.dataFilter = this.datasource;
    },

    updatePagination (pagination) {
      if (!this.$refs.tableOT) return;
      if (pagination.rowsPerPage > 10) this.$refs.tableOT.$el.style.maxHeight = 'calc(100vh - 129px)';
      else this.$refs.tableOT.$el.style.maxHeight = '622px';
    },

    async getGroup () {
      let res = await this.GetUserGroup().catch(_ => {
        return [];
      });

      this.group = [{ Id: null, Name: 'Tất cả' }, ...res] || [];
      this.selectedGroup = this.group[0];
      // console.log('🚀 ~ file: Tasks.vue ~ line 204 ~ getGroup ~ res', res);
      
    },

    handleChangeGroup (data) {
      if (data.Id) {
        localStorage.setItem('selectedGroup', JSON.stringify(data));
      }
      else { localStorage.setItem('selectedGroup', JSON.stringify(null)) }
      this.selectedGroup = data;
      this.filterDataByGroup();
    }
  }
};
</script>

<style scoped>
.no-wrap {
  white-space: nowrap;
}
.v-toolbar__items {
  padding: 7px !important;
}
.toolbar-item {
  width: 200px !important;
  margin-right: 8px !important;
}
.date-box {
  margin-right: 8px !important;
}
.table-ot{
  overflow: hidden;
  height: calc(100vh - 129px);
  max-height: 622px;
}
.table-ot >>> table{
  height: 100%;
}
.table-ot >>> thead, .table-ot >>> tfoot{  
  display: table;
  width: calc(100% - 22px);
  table-layout: fixed;
  min-width: 1608px;
}
.table-ot >>> tbody{  
  height: calc(100% - 57px);
  overflow-y: scroll;
  width: 100%;
  display: block;
  min-width: 1630px;
}
.table-ot >>> tbody tr{  
  table-layout: fixed;
  display: table;
  width: 100%;
}
.table-ot >>> .v-table__overflow{
  height: calc(100% - 59px);
}
</style>



// WEBPACK FOOTER //
// src/pages/reporting/Detail.vue